import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postPatientToLists = async (listIds, patientId) => {
  const apiURL = API_HOST + '/patient_lists_connections';
  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.post(
      apiURL,
      {
        patient_lists_connections: {
          patient_list_ids: listIds,
          user_id: patientId,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'x-dqpn-user-id': userID,
        },
      },
    );
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
